import * as React from "react";
const SvgIcCheckBold = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="m7.5 17.017-5.175-5.175 2.358-2.359L7.5 12.308l8.233-8.241 2.359 2.358L7.5 17.017Z" /></svg>;
export default SvgIcCheckBold;